<template>
  <article v-if="article" class="cta">
    <RichText :field="article.primary.cta_title" class="marked" />
    <RichText :field="article.primary.cta_description" class="sub-heading" />
    <div
      :class="{ 'buttons--single': article.items.length === 1 }"
      class="buttons"
    >
      <router-link
        v-for="button in article.items"
        v-if="button.button_link || button.btn_target"
        :to="button.button_link || button.btn_target"
        :key="`cta-${button.button_label || button.button_label[0].text}`"
      >
        <Button :icon="button.icon" class="btn-primary label-left">
          {{ button.button_label[0].text || button.button_label }}
        </Button>
      </router-link>
    </div>
  </article>
</template>

<script>
import Button from '@/components/Button';

export default {
  components: {
    Button
  },
  props: {
    article: {
      type: Object,
      required: true
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../scss/helpers/mixins';
@import '../scss/base/colors';

.cta {
  margin: 30px auto;
  max-width: 1000px;
  padding: 0 20px;
}

.marked {
  margin-top: 40px;
  margin-bottom: 1.5em;
}

.buttons {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 40px;

  a:not(:first-child) {
    margin-top: 30px;
  }
}

@include breakpoint(M) {
  .cta {
    margin-bottom: 100px;
  }

  .buttons {
    display: flex;
    flex-direction: row;

    a {
      flex: 1;
    }

    a:not(:first-child) {
      margin-top: 0;
      margin-left: 40px;

      [dir='rtl'] & {
        margin-left: 0;
        margin-right: 40px;
      }
    }

    &--single {
      display: block;

      ::v-deep .btn {
        width: auto;
      }
    }
  }
}
</style>
